import { Validator } from '../../../types/Validator';
import { isNationalId } from './isNationalId';

interface RutValidatorOptions {
  min: number;
  max: number;
  errorCode: string;
}

type RutValidator = (options: RutValidatorOptions) => Validator;

const rutValidator: RutValidator = ({ min, max, errorCode }) => value => {
  if (value === undefined) return;
  return isNationalId(value, { min, max }) ? undefined : { errorCode };
};

export { rutValidator };
